import { envVars } from '@core/environment/env-vars'
import LinkButton from '@components/buttons/link/linkButton'
import { TermsWrapper } from './accountTerms.styles'

const AccountTerms = () => (
    <TermsWrapper>
        <LinkButton
            to={envVars.REACT_APP_TERMS_AND_CONDITIONS_URL}
            external={true}
            text="At-Bay Stance Terms Of Service"
        />
    </TermsWrapper>
)

export default AccountTerms
